.modal-reset {
  background: white;
  background: var(--bg-primary);
  color: #333;
  color: var(--font-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000000000;
  flex-direction: column;
  padding: 40px;
  box-sizing: border-box;
  border-radius: 16px;
  position: relative;
  max-width: 500px;
  text-align: center;

  p {
    margin-bottom: 20px;
  }

  .action {
    display: flex;

    button {
      cursor: pointer;
      width: 100%;

      padding: 10px 20px;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 18px;
      text-align: center;
      margin: 0 5px;
      border-radius: 6px;
      box-sizing: border-box;

      &:first-child {
        border: 1px solid #0098ff;
        background: white;
        background: var(--bg-primary);
        color: #0098ff;
      }

      &:last-child {
        border: none;
        background: white;
        background: var(--blue);
        color: white;
      }

      &:focus {
        outline: none;
      }

      &:hover {
        transition: all 0.3s;

        &:first-child {
          background: #0098ff;
          color: white;
        }

        &:last-child {
          background: #007ee2;
          color: white;
        }
      }

      &:disabled {
        background: rgba(0, 0, 0, 0.12);
        background: var(--bg-disabled-button);
        border: none;
        color: rgba(0, 0, 0, 0.26);
        color: var(--font-disabled);
        cursor: not-allowed;
      }
    }
  }
}
